// extracted by mini-css-extract-plugin
module.exports = {"heading":"SectionHeading_heading__3eVqz"};